import { Box, Skeleton } from '@mui/material';

/**
 * Placeholder matching VerifyMatchTranscriptionText while transcription loads.
 * Slightly taller than a short script so the dialog does not jump when text arrives.
 */
export function VerifyMatchTranscriptionSkeleton() {
  return (
    <Box
      sx={{
        bgcolor: 'grey.50',
        borderRadius: 1,
        px: 1.5,
        py: 1,
      }}
    >
      <Skeleton variant="text" width="100%" height={24} />
      <Skeleton variant="text" width="97%" height={24} />
      <Skeleton variant="text" width="92%" height={24} />
      <Skeleton variant="text" width="70%" height={24} />
    </Box>
  );
}
